import { useReassignUserContext } from "../../context"
import { useParams } from "react-router-dom"
import { Box, FormControlLabel, Typography } from "@mui/material"
import { IOSSwitch } from "../../../../../../../../components/dynamicFormRef/switch"
import { LoadingButton } from "@mui/lab"
import { CustomTable } from "../../../../../../../../components"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"

export const Tracking = () => {
    const { id } = useParams()
    const styles = useStyles()
    const { t } = useTranslation()
    const { state, columnTracking, services, checkBossCanFollowUp } = useReassignUserContext()
    const { trackingData: { bossCanFollowUp }, trackingRow, loadings } = state

    return (
        <Box sx={styles.container}>
            <Box sx={styles.tableHeader}>
                <Typography variant="subtitle_grey" fontWeight='bold'>{t('reportFolio.tracking.tableTitle')}</Typography>

                <Box sx={styles.actionHeader}>
                    <FormControlLabel sx={styles.switch} control={<IOSSwitch checked={bossCanFollowUp} onClick={checkBossCanFollowUp} />} label={t('reportFolio.tracking.bossCanFollowUp')} />

                    <LoadingButton loading={loadings.trackingSave} variant="contained" onClick={() => { services.saveTracking({ id }) }}>{t('general.save')}</LoadingButton>
                </Box>
            </Box>

            <CustomTable
                column={columnTracking}
                row={trackingRow}
                selected={-1}
                loader={loadings.trackingTable}
            />
        </Box>
    )
}